// extracted by mini-css-extract-plugin
export default {"statsrow":"statscard_statsrow__I6HWN","statscol":"statscard_statscol__AR57s","stats__value":"statscard_stats__value__2yrzx","stats__txt":"statscard_stats__txt__ICW6b"};